import React from 'react'
import './alert.css'
class ReturnGetAlert extends React.Component{
	constructor(props){
		super(props)
	}
	render(){
		return(
			<div className="return-role-notice">

				<span className="return-role-title">龙之谷回归称号领取规则：</span>
				
				<span>1、账号领取条件，同满足以下3个条件，即可领取专属龙之谷回归称号：</span>
				<ul>
					    <li>1）心享俱乐部黄金及黄金以上会员；</li>
					
						<li>2）绑定手机下所有账号超过90天未登录任何盛趣游戏；</li> 

						<li>3）但年回归登录龙之谷游戏。 </li>

				</ul>
				<span>2、同一认证手机绑定的所有账号只可领取一次；龙之谷回归称号一年（自然年）只可领取一次。</span>
				<span className="return-role-title">龙之谷消耗礼包领取规则：</span>
			

				<span>1、账号领取条件，同满足以下3个条件，即可领取专属龙之谷回归消耗礼包</span>

				<ul>
					    <li>1）心享俱乐部黄金及黄金以上会员；</li>
					
						<li>2） 当年回归登录龙之谷游戏；</li> 

						<li>3） 即回归龙之谷后，10月24日起在游戏累计消耗达到200元、500元、1000元、3000千元时，可领取对应消耗档次的消耗礼包。 </li>

				</ul>
				<span>2、账号累计消耗计算规则</span>
				<ul>
					<li>1）累计消耗按单个账号计算</li>
					<li>2）累计消耗计算时间：从回归日起开始时间计算回归消耗</li>
				
					<li className="re-set-weight">3）回归累计消耗保留1年（自然年），年底12月31日清空，不累计至次年；</li> 
					<li>4）消耗指回归后龙之谷游戏内及官方页面上消费的点券、幸运币；点券兑换专用币及专用币兑换幸运币的兑换行为不算消耗。  </li>

				</ul>
				<span>3、同一认证手机绑定的所有账号只可领取一次；龙之谷消耗礼包一年（自然年）只可领取一次</span>
				<span>4、龙之谷wegame用户回归特权领取：</span>
				<ul>
					<li>1）回归特权鉴定：龙之谷wegame用户直接登录页面进行账号鉴定</li>
					<li>2）回归消耗礼包：回归消耗1元礼包暂不支持Wegame用户购买</li>
				</ul>
			</div>
			)

	}
}
export default ReturnGetAlert




// WEBPACK FOOTER //
// ./src/component/return-get-alert/alert.js